import React, { FC, useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Grid } from '@mui/material'
import { CurrenciesCrypto, IWallet } from '@sparling/financial-common'

import { Modal } from '../../../../components/Modal'
import { Loader } from '../../../../components/Loader'
import { createEnum } from '../../../../utils/createEnum'
import { InputField } from '../../../../components/InputField'
import { InputSelect } from '../../../../components/InputSelect'

interface Props {
  isOpen: boolean
  modalClose: () => void
  companyId: number
  companyWalletData?: IWallet
}

const ShowCompanyWalletModal: FC<Props> = ({ isOpen, modalClose, companyId, companyWalletData }) => {
  const formMethods = useForm<IWallet>()
  const [loading, setLoading] = useState<boolean>(false)

  const { setValue, reset } = formMethods

  useEffect(() => {
    if (isOpen) {
      reset()

      if (companyWalletData) {
        setValue('id', companyWalletData.id)
      }

      setLoading(false)
    }
  }, [isOpen, companyId, reset, setValue, companyWalletData])

  return (
    <Modal
      title={'Wallet Details'}
      isOpen={isOpen}
      modalClose={modalClose}
      cancelTitle={'Close'}
      width={680}
      submitButtonProps={{ visible: false }}
    >
      {loading && <Loader />}
      <FormProvider {...formMethods}>
        <Grid container spacing={2.5}>
          <Grid item xs={12} container direction="column">
            <InputSelect
              labelName={'Currency'}
              inputName="currency"
              placeholder="Please Select"
              enums={createEnum(CurrenciesCrypto)}
              width={'100%'}
              mb={20}
              defaultValue={companyWalletData?.currency}
            />
            <InputField
              labelName={'Address'}
              inputName="address"
              inputType="text"
              defaultValue={companyWalletData?.address}
              width={'100%'}
            />
            <InputField
              labelName={'Address Suffix'}
              inputName="addressSuffix"
              inputType="text"
              defaultValue={companyWalletData?.addressSuffix}
              width={'100%'}
            />
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  )
}

export const MemoShowCompanyWalletModal = React.memo(ShowCompanyWalletModal)
